module.exports = __webpack_public_path__ + "img/shenghuo.069b8682.png";